module.exports = __webpack_public_path__ + "static/apple-icon-180x180-791429dfe710d57e4f92f8b52fbc88bf.png";